import { endpoint } from "../../common/constant";
import { fetchAllPostPromisedData } from "../../common/utils/methods/commonMethods/utilityMethod";
import { failureToast } from "../../common/utils/methods/toasterFunctions/function";
import { parse2Digit } from "../otherCharges/otherChargeDetails/OtherChargeList";
import { bankNameRequiredPayModeList } from "./selectPaymentMode/components/constant";
const FullCourseLumpSum = "LUMPSUM_Full_Course";

export const ALLOWED_BU_LIST_PH2 = [
  "JP001",
  "DL482",
  "DL483",
  "DL487",
  "DL661",
  "DW087",
  "FB019",
  "GN009",
  "HR685",
  "HR686",
  "JP002",
  "ND008",
  "PL037",
  "SE004",
  "SE606",
  "RJ696",
  "DL699",
  "HR704",
  "UP727",
  "DL738",
];

const ALLOWED_BU_LIST_PH3 = [
  "AG034",
  "AD074",
  "AG032",
  "AS677",
  "AS678",
  "AS679",
  "AS680",
  "BR671",
  "BR672",
  "BR673",
  "CG692",
  "DH010",
  "DH011",
  "GP073",
  "HD411",
  "JH445",
  "JH674",
  "JH675",
  "KR036",
  "KR084",
  "MR031",
  "OR473",
  "OR474",
  "OR475",
  "OR662",
  "OR663",
  "SP028",
  "UP463",
  "UP479",
  "UP481",
  "UP484",
  "UP486",
  "UP489",
  "UP497",
  "UP617",
  "UP630",
  "UP632",
  "UP644",
  "UP646",
  "UT621",
  "UP694",
  "BR698",
  "UP723",
  "UT728",
  "UP735",
  "UP739",
  "OR740",
];

const ALLOWED_BU_LIST_PH4 = [
  "AB443",
  "AJ427",
  "AR027",
  "BH024",
  "BH430",
  "CH012",
  "HP491",
  "HP604",
  "HR026",
  "HR432",
  "HR469",
  "HR495",
  "HR624",
  "JD029",
  "JD075",
  "JK687",
  "JK688",
  "JK689",
  "JP070",
  "JR021",
  "JR049",
  "KA429",
  "KA436",
  "KO069",
  "KR033",
  "LD022",
  "NN035",
  "PA059",
  "PA060",
  "PB471",
  "PB472",
  "PB611",
  "PP025",
  "RJ462",
  "RJ466",
  "RJ467",
  "RJ490",
  "RJ608",
  "RJ610",
  "RJ614",
  "RJ620",
  "RJ681",
  "RK020",
  "SA438",
  "JK705",
  "RJ716",
];
const ALLOWED_BU_LIST_PH4_LIST2 = [
  "AN062", "AP433", "AP652", "AP669", "AP691", "BG442", "BG446", "BG447",
  "BH083", "BH410", "BI040", "BJ042", "BR041", "CL051", "CN023", "CN030",
  "CN097", "CN098", "CO052", "CO425", "HB065", "HU401", "HY044", "HY045",
  "HY082", "HY095", "HY096", "KA619", "KA626", "KA628", "KA636", "KA637",
  "KA640", "KA654", "KA667", "KL043", "KL046", "KL048", "KL089", "KL615",
  "KL676", "KN094", "KP053", "MD400", "MD465", "MG444", "MY402", "MY454",
  "NE431", "PD459", "TG496", "TG635", "TG660", "TN434", "TN622", "TN627",
  "TN629", "TN641", "TN656", "TN668", "TR090", "TR099", "TR403", "VJ091",
  "VL439", "VZ057", "VZ088", "WF064", "WR093", "TN719", "TG720", "AP492",
  "TN737"
];

const ALLOWED_BU_LIST_PH5 = [
  "AK409", "AM038", "AM047", "AM054", "AM061", "AM081",
  "BH067", "BO063", "DN690", "GJ422", "GJ458", "GJ468",
  "GJ600", "GJ609", "GJ623", "GJ648", "GJ649", "GJ664",
  "GJ682", "GO066", "GO421", "GW076", "ID050", "ID078",
  "JP072", "MB015", "MB016", "MB017", "MB018", "MB068",
  "MB415", "MB417", "MB419", "MH476", "MH478", "MH480",
  "MH493", "MH494", "MH607", "MH616", "MH631", "MH633",
  "MH634", "MH642", "MH643", "MH645", "MH647", "MH651",
  "MH657", "MH683", "MP602", "MP603", "MP613", "MP618",
  "MP639", "MP670", "PN014", "PN085", "SU056", "SU079",
  "SU457", "UJ426", "VD039", "VD080", "MP697", "GJ700",
  "GJ701", "MP707", "MP708", "MP709", "MH710", "MH711",
  "MH712", "MH714", "GJ736", "MH784"
];

const ALLOWED_BU_LIST_PH6 = [
  "IC412", "PG523", "AT311", "GJ703", "HR304", "CH519", "JK320", "OR345",
  "BR376", "BR346", "UP339", "UP731", "UP116", "MP601", "OR344", "KA522",
  "UP341", "UP518", "WB322", "UP343", "MH543", "JK325", "RJ301", "UP545",
  "UP114", "BR538", "BR733", "KA638", "BR335", "MP391", "RJ520", "GJ702",
  "CT565", "CG192", "KA529", "BR372", "UP561", "MH780", "BO127", "CD142",
  "MH779", "TG553", "MH542", "CP750", "BR363", "UP396", "MP501", "RJ774",
  "OR347", "JK785", "JM118", "UP395", "UP333", "OD340", "HR535", "RJ532",
  "JH139", "JH383", "UP531", "MP540", "KM440", "OR377", "WB314", "MP539",
  "MH778", "UP605", "UP382", "KA625", "KK194", "KK108", "KK195", "KK109",
  "KK110", "KK166", "CG112", "KT404", "RJ541", "UP546", "UP392", "BR367",
  "TG338", "UP512", "KA650", "KL460", "UP337", "DL786", "BR368", "SL307",
  "OR380", "KA776", "BR366", "UP336", "UK511", "HP533", "AS517", "UP328",
  "KK111", "BR388", "UP527", "UP390", "SN190", "SN141", "SN310", "UP342",
  "TG550", "RJ514", "UP386", "PB369", "TN350", "AS317", "KA563", "MH555",
  "HP537", "GJ544", "VN156", "VN152", "MH715", "MH385", "UP516", "MP515",
  "MH371", "MH658", "MH548", "MH684", "KA557", "BR147", "AD157", "RJ530",
  "OR381", "VS521", "LGDLP", "JH349", "RJ370", "JH327", "UP364", "MP498",
  "JH120", "HP534", "JH384", "DG123", "DL305", "NL513", "DB772", "DP135",
  "TG549", "TN775", "UP389", "HR612", "PB452", "RJ536", "GH138", "UP334",
  "JH329", "GA751", "UP560", "MH528", "BR566", "MP526", "GN902", "HR324",
  "HR552", "BR331", "HW125", "MP502", "UP393", "JH348", "JH734", "MP525",
  "WB321", "UP379", "MP121", "UP365", "MR180", "BR387", "UP330", "MB418",
  "AS119", "KA556", "DL510", "DL505", "MB161", "LGSTK", "KA567", "MH547",
  "UP783", "TN718", "GJ653", "MH524", "PT315", "PA144", "KN178", "PT115",
  "HR470", "AN319", "UP503", "JK323", "BR326", "CT554", "CT564", "RP186",
  "AP551", "UP394", "CG362", "JH706", "HR197", "OD332", "UK318"
];




export const ALLOWED_BU_LIST = [
  "DL695",
  "SE003",
  "UP666",
  "ND086",
  "DL477",
  ...ALLOWED_BU_LIST_PH2,
  ...ALLOWED_BU_LIST_PH3,
  ...ALLOWED_BU_LIST_PH4,
  ...ALLOWED_BU_LIST_PH4_LIST2,
  ...ALLOWED_BU_LIST_PH5,
  ...ALLOWED_BU_LIST_PH6
];

const restrictBUList = ["UP617"];
 

export const isAccessOfCollection = (businessAreaDropdown = []) => {
  const buDisplayList = businessAreaDropdown?.map((item) => item?.label) || [];
  return ALLOWED_BU_LIST.some((item) => buDisplayList.includes(item));
};
export const studentData = {
  bu: "JPOO1",
  studentName: "John Doe",
  psid: "123456",
  applicationId: "ABC123",
  term: "Term 1",
};

export const steps = [
  "Select charges ",
  "Select payment mode",
  "Review and Receipt",
];

export const selectedChargesFilter = [
  { label: "Paid", value: "PAID" },
  { label: "Not paid", value: "UNPAID" },
  { label: "All", value: "all" },
];

export const formattedPrice = (x, isSymbol = true) => {
  if (!x) return "₹ 0.00";
  return (
    `${isSymbol ? "₹" : ""}` +
    parse2Digit(x)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  );
};

export const isRestrictedBu = (studentBusinessArea) => {
  return restrictBUList.includes(studentBusinessArea);
};

export const createNestedMap = (arr) => {
  if (!Array.isArray(arr)) return {};
  const map = {};

  arr.forEach((item) => {
    const indices = item.split("-");

    if (indices.length === 1) {
      // It's a parent item
      const parentIndex = indices[0];
      if (!map[parentIndex]) {
        map[parentIndex] = { children: [] };
      }
    } else if (indices.length === 2) {
      // It's a child item
      const [parentIndex, childIndex] = indices;
      if (!map[parentIndex]) {
        map[parentIndex] = { children: [] };
      }
      map[parentIndex].children.push(Number(childIndex));
    }
  });

  // Convert the keys of the map to numbers for consistency
  const resultMap = {};
  Object.keys(map).forEach((key) => {
    resultMap[Number(key)] = map[key];
  });

  return resultMap;
};

export const filterKeysByValue = (obj, valueToFilter = true) => {
  if (!obj) return [];
  return Object.entries(obj)
    .filter(([key, value]) => value === valueToFilter)
    .map(([key]) => key);
};

export const calculateAmount = (selectedItemMap, itemsList) => {
  if (!selectedItemMap || !itemsList)
    return { totalAmount: 0, selectedItems: [] };
  let selectedItems = [];

  const totalAmount = Object.entries(selectedItemMap).reduce(
    (total, [index, childrenList]) => {
      const selectedItem = itemsList[index];
      if (!selectedItem) return total;

      if (Array.isArray(selectedItem.itemTypeWiseInstallmentsList)) {
        const installmentTotal = (childrenList?.children || []).reduce(
          (installmentSum, installmentIndex) => {
            const installment =
              selectedItem.itemTypeWiseInstallmentsList[installmentIndex];
            if (installment) {
              selectedItems.push(installment);
            }
            return installmentSum + (+installment?.totalBalanceAmount || 0);
          },
          0
        );
        return total + installmentTotal;
      } else {
        selectedItems.push(selectedItem);
        return total + (+selectedItem?.totalBalanceAmount || 0);
      }
    },
    0
  );

  return { totalAmount, selectedItems };
};

export function breakResponseIntoParts(data) {
  const regularCharges =
    data.regularChargesDtoList.map((charges) => {
      if (charges.installmentNo === 0) {
        return {
          ...charges,
          ...(charges?.itemTypeWiseInstallmentsList[0] ?? {}),
          itemTypeWiseInstallmentsList: "",
        };
      }
      return charges;
    }) || [];
  const otherCharges = data.otherChargesDTOList || [];
  const studentDetails = {
    applicationQuotationId: data.applicationQuotationId,
    term: data.term,
    courseId: data.courseId,
    psid: data.psid,
    upFrontAmount: data.upFrontAmount,
    isUpfrontCase: Boolean(data.upFrontAmount),
    bu: data?.businessAreaValue,
    cashierOffice: data?.cashierOffice,
    buId: data?.businessAreaId,
    applicationId: data.applicationId,
    studentName: data.studentName,
    programAction: data.programAction,
    isValidationSuccess: data.isValidationSuccess,
    isPaymentReversed: data.isPaymentReversed,
    popUpMessageList: data.popUpMessageList,
    headerMessageList: data.headerMessageList,
    lumpSumType: data.lumpsumType,
    transferApplicationId: data?.transferApplicationId,
    termId: data?.termId,
    securityConfigItemType: data?.securityConfigItemType,
    freezeAllCharges: data?.freezeAllCharges,
    isPaymentCollectionBlocked: data?.isPaymentCollectionBlocked,
    isPaymentModeJODO: data?.isPaymentModeJODO,
    academicCareerValue: data?.academicCareerValue,
    detailsMap: data?.detailsMap,
    opportunityOwnerId: data.opportunityOwnerId,
    receiptingEnabledBusinessArea : data?.receiptingEnabledBusinessArea,
    isAllowedCollectionForCourse: data?.isAllowedCollectionForCourse,

  };

  return { regularCharges, otherCharges, studentDetails };
}

export const isPaidItem = (row) => row?.status?.toLowerCase() === "paid";

export const disableForCentralizedAdmission = (row) => row?.installmentNo !== 0;

export const isFailedChequeHistory = (studentCharges, studentDetails) => {
  const failedChequeHistory =
    (studentCharges["REGULAR_CHARGES"] || []).some(
      (item) => item.failedChequeHistory
    ) ||
    (studentCharges["OTHER_CHARGES"] || []).some(
      (item) => item.failedChequeHistory
    );
  if (failedChequeHistory) {
    return (
      studentDetails?.headerMessageList?.length > 0 &&
      studentDetails?.headerMessageList
    );
  }
  return null;
};

export const isInstallmentSelected = (item) =>
  item.description.includes("Installment");

export const autoSelectLumpSumItems = (
  flag,
  currentIndexMap,
  rows,
  setSelectedIndexMapCharges
) => {
  setSelectedIndexMapCharges((prevState) => {
    const newCheckedItems = currentIndexMap;
    const isUnpaid = (row) => row.status?.toLowerCase() === "unpaid";
    rows.forEach((parent, parentIndex) => {
      if (
        parent.isAutoSelect &&
        isUnpaid(parent) &&
        isInstallmentSelected(parent)
      ) {
        // Mark the parent as checked
        newCheckedItems[parentIndex] = flag;
        if (parent.itemTypeWiseInstallmentsList) {
          parent.itemTypeWiseInstallmentsList.forEach((child, childIndex) => {
            if (child.isAutoSelect && isUnpaid(child)) {
              newCheckedItems[`${parentIndex}-${childIndex}`] = flag;
            }
          });
        }
      }
    });

    return { ["REGULAR_CHARGES"]: newCheckedItems };
  });
};
export const autoSelectSeatBookingItems = (
  flag,
  currentIndexMap,
  rows,
  setSelectedIndexMapCharges
) => {
  setSelectedIndexMapCharges((prevState) => {
    const newCheckedItems = currentIndexMap;
    const isUnpaid = (row) => row.status?.toLowerCase() === "unpaid";
    rows.forEach((parent, parentIndex) => {
      if (
        parent.isAutoSelect &&
        isUnpaid(parent)
      ) {
        // Mark the parent as checked
        newCheckedItems[parentIndex] = flag;
        if (parent.itemTypeWiseInstallmentsList) {
          parent.itemTypeWiseInstallmentsList.forEach((child, childIndex) => {
            if (child.isAutoSelect && isUnpaid(child)) {
              newCheckedItems[`${parentIndex}-${childIndex}`] = flag;
            }
          });
        }
      }
    });

    return { ["REGULAR_CHARGES"]: newCheckedItems };
  });
};
export const isUnpaid = (row) =>
  ["unpaid", "partially_paid"].includes(row.status?.toLowerCase());

export const isAllPaid = (rows = []) =>
  rows.every((row) => row.status?.toLowerCase() === "paid");

export const validateSequencing = async (
  studentBasicDetails,
  selectedCharges,
  paidAmount
) => {
  
  const request = getCreateReceiptReqObj(
    studentBasicDetails,
    paidAmount,
    selectedCharges
  );
  try {
    // opp
    const requestUpdated = {
      ...request,
      opportunityOwnerId: studentBasicDetails?.opportunityOwnerId,
    };
    const response = await fetchAllPostPromisedData(
      endpoint?.paymentCollection?.validateSequencing,
      requestUpdated,
      "post"
    );
    if (response?.code == 200) {
      return;
    } else {
      setTimeout(function () {
        window.location.reload();
      }, 5000);
    }
  } catch (error) {
    console.log(error);
  }
};

export const getCreateReceiptReqObj = (
  studentBasicDetails,
  amountToBePaid,
  selectedCharges,
  collectPayment = [],
  collectVoucherList = []
) => {
  const {
    applicationId,
    applicationQuotationId,
    psid,
    buId,
    securityConfigItemType,
    bu,
    isUpfrontCase,
    partialAddAmount
  } = studentBasicDetails;
  const appliedErpVouchers = collectVoucherList?.filter(
    (voucher) => voucher?.voucherType === "ERP"
  );
  const appliedPhoenixVouchers = collectVoucherList?.filter(
    (voucher) => voucher?.voucherType === "PHX"
  );
  let paymentModeCollectionRequestList = [
    ...collectPayment,
    ...appliedErpVouchers,
  ]?.map((el) => ({
    ...el,
    referenceNumber: (el?.referenceNumber?.label ?? el?.referenceNumber) || "",
  })); // remove cardsPayment from paymentModeCollectionRequestList
  const cardsPayments = paymentModeCollectionRequestList.filter(
    (payment) => payment?.isRemoveFromRequest
  );
  paymentModeCollectionRequestList = paymentModeCollectionRequestList.filter(
    (payment) => !payment?.isRemoveFromRequest
  );

  const isEpmrEnabled = epmrDetails(studentBasicDetails) ? true : false;
  const request = {
    applicationId,
    psid,
    businessAreaId: buId,
    businessAreaDispValue: bu,
    cashierOffice:studentBasicDetails?.cashierOffice,
    applicationQuotationId,
    isEpmrEnabled: isEpmrEnabled,
    isPartialPaymentCase:partialAddAmount>0,
    opportunityOwnerId: studentBasicDetails?.opportunityOwnerId,
    isUpfrontCase,
    totalAmountSelected: amountToBePaid,
    paymentModeCollectionRequestList:
      paymentModeCollectionRequestList.length > 0
        ? paymentModeCollectionRequestList
        : null,
    otherChargesDtoList: selectedCharges["OTHER_CHARGES"],
    regularChargesDtoList: selectedCharges["REGULAR_CHARGES"],
    // phoenixNonReceiptedIds: appliedPhoenixVouchers?.map(
    //   (voucher) => voucher?.vId
    // ),
    paymentVoucherDtoList : appliedPhoenixVouchers?.map(({vId , paidAmount}) => ({
      id : vId,
      paidAmount
    })),
    securityConfigItemType,
  };

  // if (cardsPayments?.length > 0) {
  //   request.phoenixNonReceiptedIds = [
  //     ...request.phoenixNonReceiptedIds,
  //     ...cardsPayments.map((item) => item.txnId),
  //   ];
  // }
  if (cardsPayments?.length > 0) {
    request.paymentVoucherDtoList = [
      ...request.paymentVoucherDtoList,
      ...cardsPayments.map(({txnId, paidAmount}) => ({
        id : txnId,
        paidAmount
      })),
    ];
  }
  return request;
};

export const handleStripMessages = (headerMessageList, setTopStrip) => {
  const mgsList = (headerMessageList || []).map((item) => ({
    isSuccess: item?.messageType === "INFO",
    isWarning: item?.messageType === "WARN",
    isError: item?.messageType === "ERROR",
    content: item?.message,
  }));

  setTopStrip({
    isShow: true,
    mgsList,
  });
};

export function capitalizeFirstLetter(text) {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

export function formatNumber(number) {
  return number.toString().padStart(2, "0");
}

export const reviewReceipt = async (
  studentBasicDetails,
  paidAmount,
  selectedCharges,
  collectPayment = [],
  collectVoucherList = []
) => {
  const req = getCreateReceiptReqObj(
    studentBasicDetails,
    paidAmount,
    selectedCharges,
    collectPayment,
    collectVoucherList
  );
  try {
    const res = await fetchAllPostPromisedData(
      endpoint?.paymentCollection?.review,
      req,
      "post"
    );
    if (res?.code == 200) {
      return true;
    } else return false;
  } catch (error) {
    console.log(error);
  }
};

export const isUpFrontOrEpmrEnabled = (details) =>
  details?.upFrontAmount ||
  details?.detailsMap?.EpmrValidationEnabled ||
  details?.detailsMap?.hasPDCCharge;

export const isSeatBookingEnabled = (details) =>
  details?.detailsMap?.seatBooking

export const isChequeEnabled = (details) =>
  details?.detailsMap?.isChequeAutoCheck

export const isEnachEnabled = (details) =>
  details?.detailsMap?.isJodoAutoCheck

export const isPopupMessageExist = (studentBasicDetails) => {
  return studentBasicDetails?.popUpMessageList?.length;
};

export const isUptoIstallmentEnabled= (details) =>{
  return details?.detailsMap?.chargesSubType == "UPTO_1st";
}

export const epmrValidationMessages = () => {
  return {
    titleMessage: "EPMR Validation",
    detailMessage:
      "Some charges have been auto-selected as there is an existing unreceipted payment through EPMR. Please verify the payment details before proceeding",
    messageType: "WARNING_MESSAGE",
    isOpen: true,
    isFromEpmr: true, //
  };
};

export const createPaymentModeItem = (details) => {
  const {
    paidAmount = 0,
    paymentMode = null,
    bankName = null,
    cardType = null,
    paymentModeId = null,
    epmrNumber = null,
    referenceNumber = null,
    bankMasterId = null,
    paymentModeDate = null,
  } = details?.detailsMap?.EpmrValidationEnabled || {};
  return {
    paidAmount,
    paymentMode,
    bankName,
    cardType,
    paymentModeId,
    epmrNumber,
    referenceNumber,
    bankMasterId,
    paymentModeDate,
    isEmprReceipt: true,
  };
};

export const epmrDetails = (studentBasicDetails) => {
  return studentBasicDetails?.detailsMap?.EpmrValidationEnabled;
};

export function getSelectedItemList(selectedCharges) {
  const { REGULAR_CHARGES = [], OTHER_CHARGES = [] } = selectedCharges || {};
  return REGULAR_CHARGES.length > 0 ? REGULAR_CHARGES : OTHER_CHARGES;
}
// in case of loan show this message while partial payment
export const getErrorMessage = (messages = []) => {
  const temp = [...messages];
  if (temp) {
    const first = temp.pop();
    const [firstMessage, restMessage] = first?.detailMessage?.split("This");
    return `${firstMessage?.replace(
      "text-dark",
      "text"
    )}So partial payment is not allowed.`;
  }
};

export const getNetItemsBalance = (selectedItems = []) => {
  return selectedItems.reduce(
    (acc, item) => acc + item["totalBalanceAmount"],
    0
  );
};

export const shouldShowUploadChequePopup = (
  epmrReceiptDetails,
  collectPayment
) => {
  return (
    epmrReceiptDetails &&
    collectPayment.length > 0 &&
    !(
      collectPayment[0]?.paymentModeAttachmentS3Key ||
      (["CC", "OP", "MPOS"].includes(collectPayment[0]?.paymentMode) &&
        collectPayment[0]?.bankNameCustom)
    ) &&
    bankNameRequiredPayModeList.includes(collectPayment[0]?.paymentMode)
  );
};

export const isLumpSumItemSelected = (itemList = []) => {
  return itemList.some((item) => item.isAutoSelect);
};
